import constantObject from 'utilities/constantObject';

export const STATUSES = constantObject([
  'INITIAL',
  'LOADING',
  'LOADED',
  'ERROR',
]);
